"use client";

import { useTranslations } from "~/hooks/useTranslations";
import adac from "~/assets/ADAC.svg";
import { Banner } from "./Banner";

export function DTMMembershipBanner(): JSX.Element {
  const t = useTranslations();

  return (
    <Banner
      title={t.dtm.membership.title}
      description={t.dtm.membership.description}
      buttonLabel={t.dtm.membership.button}
      buttonLink="https://www.adac.de/mitgliedschaft/mitglied-werden/?ref=dtmticketshop"
      image={{
        url: adac,
        dimensions: {
          width: 200,
          height: 200,
        },
      }}
    />
  )
}
